(function () {
  function resetKustomButtons() {
    document.querySelectorAll('[data-kustom-checkout]').forEach(function (btn) {
      btn.disabled = false;
      var textEl = btn.querySelector('.button-text');
      if (textEl) textEl.textContent = 'Betala säkert med Kustom';
    });
  }

  window.addEventListener('pageshow', resetKustomButtons);
  window.addEventListener('pagereveal', resetKustomButtons);

  async function handleKustomClick(e) {
    var btn = e.target.closest('[data-kustom-checkout]');
    if (!btn || btn.disabled) return;

    var errEl = btn.parentElement && btn.parentElement.querySelector('.kustom-btn-error');
    var textEl = btn.querySelector('.button-text');
    btn.disabled = true;
    if (textEl) textEl.textContent = 'Laddar...';
    if (errEl) errEl.style.display = 'none';

    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });

      if (!cart.items || cart.items.length === 0) {
        window.location.reload();
        return;
      }

      var country = btn.dataset.country || 'SE';

      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        btn.dataset.currency ||
        'SEK';

      var shopifyLang = window.Shopify && window.Shopify.locale;
      var locale;
      if (shopifyLang) {
        locale = shopifyLang.includes('-') ? shopifyLang : shopifyLang + '-' + country;
      } else {
        locale = btn.dataset.locale || 'sv-SE';
      }

      var market = { country: country, currency: currency, locale: locale };

      var res = await fetch('https://k-worker.alexander-9c6.workers.dev/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, cart, { _market: market })),
      });
      var data = await res.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        throw new Error(data.error || 'Något gick fel');
      }
    } catch (err) {
      btn.disabled = false;
      if (textEl) textEl.textContent = 'Betala säkert med Kustom';
      if (errEl) { errEl.textContent = err.message; errEl.style.display = 'block'; }
    }
  }

  document.addEventListener('click', handleKustomClick);
})();